module.exports = __webpack_public_path__ + "img/messages_notification_black.ed5d445f.svg";